import { Component, OnInit, Renderer2 } from '@angular/core';
import {Location} from '@angular/common';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/app/_services/database.service';

@Component({
  selector: 'app-notification-detail',
  templateUrl: './detail.component.html'
})
export class NotificationDetailComponent implements OnInit {
  status:boolean = false
  
  constructor(public dialog : MatDialog, private render: Renderer2,public activatedroute:ActivatedRoute ,private _location: Location,public db:DatabaseService) { }
  
  ngOnInit() {
    this.getDetail(this.activatedroute.snapshot.params.id)
    
  }
  mainData:any={};
  data:any={};
  getDetail(id){
    this.db.presentLoader();
    let reqData = {
      "type" : "sfa",
      "filter": {
          "notification_code": this.activatedroute.snapshot.params.code
      },
      "limit": 100000,
      "start": 0
  }
    this.db.postReq(reqData,'notification/detail').subscribe(resp=>{
      this.db.dismissLoader();
      if(resp['status'] == 'success'){
        this.data = resp['result'].detail;   
        this.mainData = this.data[0]
        console.log(this.data);
        
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errHandler(err);
    })
    
  }
  backClicked() {
    this._location.back();
  }
  
  
  toggleNav() 
  {
    this.status = !this.status;
    if(this.status) {
      this.render.addClass(document.body, 'toggle-active');
    }
    else {
      this.render.removeClass(document.body, 'toggle-active');
    }
  }
}
